export const capitalizeFirstLetter = (text: string | undefined): string => {
  if (text === undefined) {
    return '';
  }
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};
